import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getCourses, getFeaturedCourse } from '../redux/actions';
import { selectCourses, selectUserCourseIds } from '../redux/selectors';
import { hasActiveSubscription } from '../../redux/selectors';
import Icon from '../../../common/icons/Icon';
import Loading from '../../../common/components/Loading';
import moment from 'moment';
import { sendIntercomEvent } from '../../../common/events';

class CourseList extends Component {
  static propTypes = {
    activeSubscription: PropTypes.bool.isRequired,
    courses: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    featuredCourse: PropTypes.object,
  };

  componentDidMount() {
    const { activeSubscription } = this.props;
    this.props.dispatch(getCourses());

    if (activeSubscription) {
      this.props.dispatch(getFeaturedCourse());
    }
    sendIntercomEvent('viewed_courses');
  }

  renderFeatured = () => {
    const course = this.props.featuredCourse;

    return (
      <div
        style={course.has('image') ? { backgroundImage: `url(${course.getIn(['image', 'location'])})` } : {}}
        className="hero__wrapper course__hero__wrapper"
      >
        <Helmet>
          <title>Tathata Golf - Courses</title>
        </Helmet>
        <div className="container">
          <div className="course__hero">
            <h1>{course.get('name')}</h1>
            <p>{course.get('description')}</p>
            <div className="featured-course__status">
              {course.get('progress') ? (
                <div className="course-progress">
                  <div className="course-progress__bar">
                    <div
                      className="course-progress__bar course-progress__bar--progress"
                      style={{ width: `${course.get('progress') * 3}px` }}
                    />
                  </div>
                  <span>{course.get('progress')}%</span>
                </div>
              ) : null}
              <Link to={`./courses/${course.get('id')}`}>
                <span className="button">{course.get('progress') ? 'Continue' : 'Start Course'}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { activeSubscription, courses, featuredCourse } = this.props;

    if (!courses || (activeSubscription && !featuredCourse)) {
      return <Loading />;
    }

    return (
      <div>
        {activeSubscription ? this.renderFeatured() : null}
        <div className="container">
          <div className="course-list">
            <h3>All Courses</h3>
            <div className="course-list__container">
              {!courses.length ? (
                <div>You do not have any purchased courses.</div>
              ) : (
                courses.map(course => (
                  <Link to={`./courses/${course.id}`} className="course-card" key={course.id}>
                    <div className="course-card__badge">
                      {course.icon_id ? (
                        <div
                          className="course-card__icon"
                          style={{ backgroundImage: `url(${course.icon.location})` }}
                          alt={course.badge.name}
                        />
                      ) : (
                        <div className="temporary-badge" />
                      )}
                      {course.complete ? <Icon icon="CheckmarkCircle" /> : null}
                    </div>
                    <div className="course-card__info">
                      <div className="course-card__title">{course.name}</div>
                      <p>
                        {course.description.length > 175
                          ? course.description.substr(0, 173) + '...'
                          : course.description}
                      </p>
                      {course.progress ? (
                        <div>
                          {course.complete ? (
                            <div className="course-progress course-progress--complete">
                              <span>Course completed on {moment(course.completed_at).format('L')}</span>
                            </div>
                          ) : (
                            <div className="course-progress">
                              <div className="course-progress__bar">
                                <div
                                  className="course-progress__bar course-progress__bar--progress"
                                  style={{ width: `${course.progress * 3}px` }}
                                />
                              </div>
                              <span>{course.progress}%</span>
                            </div>
                          )}
                        </div>
                      ) : null}
                    </div>
                  </Link>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const activeSubscription = hasActiveSubscription(state);
  const userCourseIds = selectUserCourseIds(state);
  let courses = selectCourses(state);
  if (!activeSubscription && courses) {
    courses = courses.filter(course => userCourseIds.indexOf(course.id) > -1);
  }
  return {
    activeSubscription,
    courses,
    featuredCourse: state.subscription.courses.featuredCourse.get('data'),
  };
};

export default connect(mapStateToProps)(CourseList);



// WEBPACK FOOTER //
// ./src/subscription/courses/views/CourseList.js